import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import SEOMeta from "@/components/base/SEOMeta";
import Hero from "./components/Hero";
import ServiceCategories from "./components/ServiceCategories";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import CTA from "./components/CTA";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="安大师 - 专业安全防护解决方案"
        description="安大师是您值得信赖的专业安全防护品牌，提供全面的安全解决方案与专家级服务。无论是家庭安全、企业防护还是个人保障，安大师凭借多年行业经验，为您量身定制最优方案，让安全无忧成为日常。"
        keywords="安大师,安大师官网,安大师安全服务,安大师专业防护,安大师解决方案,安大师评价,安大师使用教程"
        canonicalUrl="https://www.anmaster.com/"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "安大师",
            url: "https://www.anmaster.com/",
            description:
              "安大师是您值得信赖的专业安全防护品牌，提供全面的安全解决方案与专家级服务。",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.anmaster.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />

      <Navbar />
      <main>
        <Hero />
        <ServiceCategories />
        <Features />
        <Testimonials />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </>
  );
}